import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../dataProvider/APIPaths';
import { IQuestionTag } from '../QuestionSlice';
import APIDataProvider from '../../dataProvider/APIDataProvider';

export interface IAdminGetQuestionTagList {
  limit: number;
  offset: number;
  name: string;
}

const TagsApiDataProvider = new APIDataProvider<IQuestionTag>();

export const getTagsList = createAsyncThunk(
  'tags/list',
  async (data: IAdminGetQuestionTagList) => {
    const response = await TagsApiDataProvider.get(
      `${ApiPaths.tags}?limit=${data.limit}&offset=${data.offset}&name=${data.name}`
    );
    return response.data as {
      limit: number;
      offset: number;
      totalDocs: number;
      docs: Array<IQuestionTag>;
    };
  }
);
